<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        :id="`popover-create`"
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <div class="inner-header--create">
              <strong class="mr-auto"> Crea un nuovo produttore </strong>
              <b-button
                class="btn btn--create btn--smaller"
                type="button"
                variant="primary"
                size="sm"
                @click="onAdd"
                title="Crea un nuovo produttore"
                :disabled="!canVerb(resource, 'store')"
              >
                <base-icon name="circled_plus" width="16" height="16" />
                <span>Crea</span>
              </b-button>
            </div>
            <div class="inner-header--info">
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </div>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-input
                name="NOM"
                type="text"
                label="Nominativo"
                v-model="filter.byCustom.title.value"
                placeholder="Inserisci un nome"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="BUID"
                type="text"
                label="Codice"
                v-model="filter.byAttribute.BUID"
                placeholder="Inserisci un codice"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="BCONS"
                type="text"
                label="Consulente"
                v-model="filter.byCustom.BCONS.value"
                placeholder="Inserisci un consulente"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <salesmen
        @edit="onEdit"
        @manualFetch="manualFetch"
        :fields="elaborateAllFields"
        :repository="repository"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        @rowSelector="commission"
        :resource="resource"
        :filterName="filterName"
        @destroy="onDestroy"
        :filterOn="{
          byRelations: ['byCorrespondence', 'byAddressBook'],
        }"
        :onlyActions="['edit', 'infomodal']"
        :ref="tableRef"
        includeRowSelector
      ></salesmen>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import Salesmen from "@/components/tables/Salesmen";
import BaseInput from "@/components/form/BaseInput";
import { mapActions } from "vuex";
import { computed } from "vue";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";
import StorageGetterMixin from "../../../../mixins/StorageGetterMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      args: {},
      repository: "broker",
      resource: "brokers",
      context: "profile_brokers",
      tableRef: "SalesmenTableRef",
      filterName: "filterSalesmen",
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      fields: [
        {
          key: "rowSelector",
          label: "Provvigioni",
          sortable: false,
          thStyle: {
            width: "90px",
          },
        },
        {
          key: "attributables.BUID",
          label: this.getDictionary("attribute_BUID_value", "broker"),
          sortable: true,
          sortKey: "BUID",
        },
        {
          key: "attributables.SURN",
          label: this.getDictionary("attribute_SURN_value", "broker"),
          sortable: true,
          sortKey: "SURN",
        },
        {
          key: "attributables.NAME",
          label: this.getDictionary("attribute_NAME_value", "broker"),
          sortable: true,
          sortKey: "NAME",
        },
        {
          key: "attributables.CNAM",
          label: this.getDictionary("attribute_CNAM_value", "broker"),
          sortable: true,
          sortKey: "CNAM",
        },
        {
          key: "attributables.BCONS",
          label: this.getDictionary("attribute_BCONS_value", "broker"),
          sortable: true,
          sortKey: "BCONS",
        },
        {
          key: "attributables.SEEX",
          label: this.getDictionary("attribute_SEEX_value", "broker"),
          formatter: (value) => (value === "Y" ? "SI" : "NO"),
          sortable: false,
        },
        {
          key: "attributables.REDE",
          label: this.getDictionary("attribute_REDE_value", "broker"),
          formatter: (value) => (value === "Y" ? "SI" : "NO"),
          sortable: false,
        },
        {
          key: "attributables.REPE",
          label: this.getDictionary("attribute_REPE_value", "broker"),
          formatter: (value) => (value === "Y" ? "SI" : "NO"),
          sortable: false,
        },
        {
          key: "attributables.READ",
          label: this.getDictionary("attribute_READ_value", "broker"),
          formatter: (value) => (value === "Y" ? "SI" : "NO"),
          sortable: false,
        },
        {
          key: "status_broker",
          label: this.getDictionary("status_broker", "broker"),
        },
        {
          key: "fattutto",
          label: this.getDictionary("Flusso contabilità fiscale"),
          sortable: false,
        },
      ],
    };
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      args: computed(() => this.args),
    };
  },
  components: {
    BaseIcon,
    Salesmen,
    BaseInput,
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    elaborateAllFields() {
      let ret = this.fields;
      if (this.hasPoldo) {
        ret.push({
          key: "attributables.SUBA",
          label: "SUBA per PolDo",
          sortable: true,
          sortKey: "SUBA",
        });
      }
      return ret;
    },
    hasPoldo() {
      return this.$store.state.auth.settings.attributables.POLDO &&
        this.$store.state.auth.settings.attributables.POLDO === "Y"
        ? true
        : false;
    },
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("councils"))
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("provinces"))
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {})
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          status_broker: 0,
          title: null,
          NAME: null,
          SURN: null,
          BUID: null,
        },
        byCustom: {
          title: {
            value: null,
            likewise: 3,
            filter: "byAttribute",
          },
          BCONS: {
            value: null,
            likewise: 3,
            filter: "byAttribute",
          },
        },
      };
      return init;
    },
    commission(item) {
      this.$router.push({
        name: "brokers.pivot",
        params: { id: `${item.id}` },
      });
    },
    onEdit(id, item) {
      this.$router.push({
        name: `brokers.edit0`,
        params: { id: `${id}`, item: item },
      });
    },
    onAdd() {
      this.$router.push({ name: `brokers.create0` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      delete this.activeFilters["byAttribute.status_broker"];
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
  },
  mounted() {
    this.onSearch(this.filterName);
    // this.$refs[this.tableRef].fetch();
  },
};
</script>
